module.exports = __webpack_public_path__ + "img/invite_banner.19e5d85c.png";